<template>
  <span v-html="htmlText">
  </span>
</template>
<script>
import { isEmpty } from '@/utils/helpers'

export default {
  props: {
    item: {
      type: String,
      default: ''
    },
    errorInfo: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      htmlText: ''
    }
  },
  mounted () {
    this.hitHighLight(this.item, this.errorInfo)
  },
  methods: {
    encode(keyword) {
      const reg = /[\[\(\$\^\.\]\*\\\?\+\{\}\\|\)]/gi
      return keyword.replace(reg, (key) => `\\${key}`)
    },
    hitHighLight (item, errorInfo) {
      if (!isEmpty(item)) {
        if (!isEmpty(errorInfo)) {
          this.handlerSingleData(item, errorInfo.hitError, errorInfo.color)
        }
      }
    },
    handlerSingleData (item, val, color) {
      const reg = new RegExp(`${this.encode(val)}`, 'ig')
      this.htmlText = item.replace(reg, (key) => {
        return `<span style="color: ${color}">${key}</span>`
      })
    }
  }
}
</script>
